import { signOut } from '../lib/auth.js';

/**
 * Fail-closed "request access" screen (FR-018, US3). An authenticated Principal
 * with no mapped role lands here instead of the app — every protected operation
 * is also denied server-side (403). Sign-out stays available so the user can
 * leave or switch accounts.
 */
export function RequestAccessView() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-surface-app px-4 py-10">
      <section className="w-full max-w-[480px] text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.08em] text-text-secondary">
          Suvoda UAT
        </p>
        <h1 className="mt-2 text-[28px] font-semibold leading-tight text-text-primary">
          Access pending
        </h1>
        <p className="mt-4 text-sm text-text-secondary">
          You’re signed in, but your account hasn’t been granted a role yet. Ask your administrator
          to add you to the appropriate Okta group, then sign in again.
        </p>
        <button
          type="button"
          onClick={() => signOut()}
          className="mt-6 text-sm font-semibold text-text-primary underline"
        >
          Sign out
        </button>
      </section>
    </main>
  );
}
